<template>
  <div v-if="visible" class="update-info-modal-overlay" @click.self="$emit('close')">
    <div class="update-info-modal-box">
      <div class="update-info-modal-hd">
        <h3>
          <i class="fa fa-info-circle" style="color:#005f78; font-size:1.3em; line-height:1.2;"></i>
          商品プレビュー
        </h3>
        <button class="update-info-modal-close" @click="$emit('close')">×</button>
      </div>

      <div class="update-info-modal-body">
        <div class="update-info-img-col">
          <div class="update-info-img-card">
            <div class="update-info-img-main">
              <img v-if="modalData.images && modalData.images.length > 0" :src="modalData.images[activeImageIndex].src" alt="メイン画像">
              <div v-else class="update-info-img-placeholder">No Image</div>
            </div>
            <div v-if="modalData.images && modalData.images.length > 0" class="update-info-img-date-badge">
              <span class="badge-label">更新日付</span>
              <span class="badge-val">{{ modalData.images[activeImageIndex].date }}</span>
            </div>
          </div>
          <div class="update-info-img-strip">
            <div
              v-for="(img, idx) in modalData.images"
              :key="idx"
              class="update-info-thumb"
              :class="{ 'update-info-thumb--active': idx === activeImageIndex }"
              @click="activeImageIndex = idx"
            >
              <img :src="img.srcThumbnail" alt="Thumbnail">
            </div>
          </div>
          <div class="update-info-img-count" v-if="modalData.images && modalData.images.some(img => img.src)">
            <span class="img-count-num">{{ modalData.images.filter(img => img.src).length }}</span><span class="img-count-unit">枚の画像</span>
          </div>
        </div>

        <div class="update-info-info-col">
          <span class="update-info-text-update-chip">
            テキスト更新&nbsp;<span class="update-info-text-update-date">{{ modalData.textUpdateDate }}</span>
          </span>
          <div class="update-info-title-block">
            <div class="update-info-title-label">
              <svg width="10" height="10" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4.5" stroke="#ff9900" stroke-width="1" fill="none"/></svg>
              商品タイトル
            </div>
            <div class="update-info-title-text">{{ modalData.title }}</div>
            <div class="update-info-asin-row" v-if="modalData.asin">
              <span class="update-info-asin-badge update-info-asin-badge--asin">ASIN: {{ modalData.asin }}</span>
              <span class="update-info-asin-badge">サイズ：{{ modalData.amazonSize || '-' }}</span>
              <span class="update-info-asin-badge">カラー：{{ modalData.amazonColor || '-' }}</span>
            </div>
          </div>

          <div class="update-info-review-block">
            <div class="update-info-section-label">商品説明</div>
            <div class="update-info-desc-wrapper">
              <div
                ref="descContent"
                class="update-info-desc-content"
                :class="{ 'update-info-desc-content--collapsed': !isDescExpanded }"
              >
                <div class="update-info-feature-text" v-html="modalData.features"></div>
                <div v-if="modalData.features && modalData.review" class="update-info-desc-spacer"></div>
                <div class="update-info-review-text" v-html="modalData.review"></div>
              </div>
              <template v-if="isOverflowing && !isDescExpanded">
                <div class="update-info-fade-overlay">
                  <span class="update-info-ellipsis">…</span>
                  <button class="update-info-show-all-btn" @click="isDescExpanded = true">
                    <i class="fa fa-chevron-down update-info-btn-icon"></i>すべて表示する
                  </button>
                </div>
              </template>
              <button
                v-if="isDescExpanded"
                class="update-info-show-all-btn update-info-collapse-btn"
                @click="collapseDesc"
              >
                <i class="fa fa-chevron-up update-info-btn-icon"></i>折りたたむ
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="update-info-modal-ft">
        <button class="update-info-btn-cancel" @click="$emit('close')">閉じる</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AmazonUpdateInfoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => ({
        asin: '',
        amazonSize: '',
        amazonColor: '',
        title: '',
        images: [],
        features: '',
        review: '',
        textUpdateDate: ''
      })
    }
  },
  data () {
    return {
      activeImageIndex: 0,
      isDescExpanded: false,
      isOverflowing: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.activeImageIndex = 0
        this.isDescExpanded = false
        this.$nextTick(this.checkOverflow)
      }
    },
    modalData () {
      this.$nextTick(this.checkOverflow)
    }
  },
  methods: {
    checkOverflow () {
      const el = this.$refs.descContent
      if (el) {
        this.isOverflowing = el.scrollHeight > el.clientHeight
      }
    },
    collapseDesc () {
      this.isDescExpanded = false
      this.$nextTick(() => {
        if (this.$refs.descContent) {
          this.$refs.descContent.scrollTop = 0
        }
        this.checkOverflow()
      })
    }
  }
}
</script>

<style scoped>
.update-info-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.42);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.update-info-modal-box {
  background: #fff;
  border-radius: 8px;
  width: 930px;
  height: 610px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.update-info-modal-hd {
  background: #d0f2f8;
  border-bottom: 1px solid #7dcee8;
  padding: 11px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.update-info-modal-hd h3 {
  font-size: 16px;
  color: #005f78;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: 700;
}
.update-info-modal-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}
.update-info-modal-close:hover { color: #c00; }
.update-info-modal-body {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.update-info-img-col {
  width: 270px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  border-right: 1px solid #e5e9ef;
  padding: 14px 12px;
  gap: 10px;
  overflow: hidden;
}
.update-info-img-card {
  border: 1px solid #dde3ec;
  border-radius: 6px;
  overflow: hidden;
}
.update-info-img-main {
  width: 100%;
  aspect-ratio: 1/1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  position: relative;
}
.update-info-img-main img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.update-info-img-placeholder {
  color: #aaa;
  font-size: 13px;
}
.update-info-img-date-badge {
  background: rgba(0,0,0,0.52);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.update-info-img-date-badge .badge-label { color: #aedff7; font-weight: 500; }
.update-info-img-strip {
  display: grid;
  grid-template-columns: repeat(auto-fill, 52px);
  justify-content: space-between;
  align-content: start;
  gap: 6px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.update-info-thumb {
  width: 52px;
  height: 52px;
  border: 2px solid #e0e6ef;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s;
}
.update-info-thumb:hover,
.update-info-thumb--active { border-color: #ff9900; }
.update-info-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.update-info-img-count {
  font-size: 11px;
  color: #999;
  text-align: center;
}
.img-count-num {
  font-size: 14px;
  font-weight: 700;
  color: #555;
}
.img-count-unit {
  font-size: 11px;
  color: #999;
}
.update-info-info-col {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 18px;
  gap: 14px;
}
.update-info-title-block {
  background: #fff;
  border: 1px solid #eef1f5;
  border-radius: 6px;
  padding: 12px 14px;
}
.update-info-title-label {
  font-size: 12px;
  font-weight: 700;
  color: #ff9900;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.update-info-title-text {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.5;
}
.update-info-asin-row {
  display: flex;
  flex-wrap: wrap;
  gap: 36px;
  margin-top: 6px;
}
.update-info-asin-badge {
  font-size: 13px;
  color: #888;
}
.update-info-asin-badge:not(.update-info-asin-badge--asin) {
  color: #1a1a1a;
  font-weight: 700;
}
.update-info-asin-badge--asin {
  display: inline-block;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 1px 7px;
}
.update-info-text-update-chip {
  align-self: flex-end;
  font-size: 12px;
  color: #666;
  background: #f0f4f8;
  border: 1px solid #dde3ec;
  border-radius: 4px;
  padding: 3px 10px;
}
.update-info-text-update-date { color: #1a1a1a; font-weight: 700}
.update-info-desc-spacer {
  height: 1em;
}
.update-info-section-label {
  font-size: 14px;
  font-weight: 700;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}
.update-info-feature-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.update-info-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  font-size: 14px;
  color: #333;
  padding: 4px 8px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #eee;
  line-height: 1.4;
}
.update-info-feature-icon {
  color: #27ae60;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 1px;
  font-weight: 700;
}
.update-info-review-block {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fafbfc;
  border: 1px solid #eef1f5;
  border-radius: 6px;
  padding: 12px 14px;
  overflow: hidden;
}
.update-info-feature-text {
  line-height: 2.2;
  font-size: 14px;
}
.update-info-review-text {
  font-size: 14px;
  color: #555;
  line-height: 2.2;
}
.update-info-modal-ft {
  border-top: 1px solid #eee;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}
.update-info-btn-cancel {
  font-size: 14px;
  color: #666;
  background: #f5f5f5;
  border: 1px solid #ccc;
  padding: 5px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}
.update-info-btn-cancel:hover { background: #eee; }
.update-info-desc-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
.update-info-desc-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.update-info-desc-content--collapsed {
  max-height: 210px;
  overflow: hidden;
}
.update-info-fade-overlay {
  flex-shrink: 0;
  position: relative;
  background: linear-gradient(to bottom, rgba(250,251,252,0) 0%, rgba(250,251,252,0.85) 30%, rgba(250,251,252,1) 70%);
  margin-top: -120px;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.update-info-ellipsis {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #888;
  line-height: 1;
  padding: 0 2px 4px 2px;
  letter-spacing: 2px;
}
.update-info-show-all-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  flex-shrink: 0;
  padding: 7px 0 5px;
  font-size: 13px;
  font-weight: 600;
  color: #0073bb;
  background: none;
  border: none;
  border-top: 1px solid #e8ecf0;
  cursor: pointer;
  text-align: center;
  letter-spacing: 0.01em;
}
.update-info-show-all-btn:hover {
  color: #c45500;
  background: rgba(0,0,0,0.03);
}
.update-info-btn-icon {
  font-size: 11px;
}
.update-info-collapse-btn {
  color: #555;
}
.update-info-collapse-btn:hover {
  color: #c45500;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/AmazonUpdateInfoModal.vue